// Reference snapshot for the existing restricted CE surface; no live Touski connection.
// Touski company/shareholders read on 2026-09-21; source edits June 2026.
// Personal capital allocations are served exclusively by the private CE API.
export const bzHoldings = [
  { name: 'BZ Telecom inc', percent: 30, source: 'Touski · 15 juin 2026', note: 'Participation directe de BZ inc.' },
  { name: 'Gestion KiloOctets inc', percent: 90, source: 'Touski · 15 juin 2026', note: 'Les 10 % restants sont détenus par BZ Telecom.' },
  { name: 'Agentique AIKUB inc', percent: 20, source: 'Confirmé par Dany · 21 septembre 2026', note: 'Confirmation distincte du relevé Touski de juin.' },
] as const;
export const capitalPercent = (basisPoints: number) => (basisPoints / 100).toLocaleString('fr-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' %';
